import { ChangeDetectorRef, Component, OnInit } from '@angular/core';

import { FormsModule } from '@angular/forms';
import { SharedModule } from '../shared/shared.module';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { ApiCallService } from '../services/api-call.service';
import { UtilService } from '@app/shared/services/util.service';
import { LoggerService } from '@app/shared/services/logger.service';
import moment from 'moment';

@Component({
    imports: [FormsModule, SharedModule, RouterModule],
    selector: 'app-apikey-logs',
    templateUrl: './apikey-logs.component.html',
    styleUrls: ['./apikey-logs.component.css']
})
export class ApikeyLogsComponent implements OnInit {

  keyId: string | null = null;
  keyLogs: any = [];
  loading = false;
  displayedColumns: any = [
    {
      name: 'S.No.',
      dataKey: 'sno',
      position: 'left',
      isSortable: true,
      type: '',
    },
    {
      name: 'Request Path',
      dataKey: 'path',
      position: 'left',
      type: 'text',
      isSortable: true,
    },
    {
      name: 'Request Method',
      dataKey: 'method',
      position: 'left',
      type: 'text',
      isSortable: true,
    },
    {
      name: 'Request Browser',
      dataKey: 'request_browser',
      position: 'left',
      type: 'text',
      isSortable: true,
    },
    {
      name: 'Used At',
      dataKey: 'created_at',
      position: 'left',
      type: 'text',
      isSortable: true,
    },
  ];

  constructor(
    private route: ActivatedRoute,
    private apiKeyService: ApiCallService, 
    private cdr: ChangeDetectorRef, 
    private router: Router,
    private util: UtilService,
    private logger: LoggerService
  ) { }

  ngOnInit(): void {
    this.route.paramMap.subscribe(params => {
      this.keyId = params.get('keyId')!;
    });

    this.fetchKeys();
  }

  fetchKeys() {
    this.loading = true;
    this.apiKeyService.getLogsById(this.keyId).subscribe(
       (data: any) => {
         const response = data['body']['responseBody'];
         if (response) {
          this.keyLogs = response.map(item => ({
            ...item,
            created_at: moment(item.created_at).format('DD-MMM-YYYY HH:mm:ss'),
          }));
          this.loading = false; // Hide loading state
          this.cdr.detectChanges();
         } else {
          this.keyLogs = [];
          this.loading = false; // Hide loading state
          this.cdr.detectChanges();
         }
       },
       (error) => {
         this.loading = false; // Hide loading state
         this.cdr.detectChanges();
         console.error('Error fetching revision history:', error);
       }
     );
  }

}
